import React from 'react';
export const RouterContext = /*#__PURE__*/React.createContext(null);
//# sourceMappingURL=context.js.map